module.exports = __webpack_public_path__ + "img/logo-pulih.5f46ff2e.png";